export default {
  'menu.welcome': '欢迎',
  'menu.login': '登录',
  'menu.dashboard': '仪表盘',
  'menu.test-api': 'API测试',
  
  // 活动管理
  'menu.activity': '活动管理',
  'menu.activity.activity-list': '活动列表',
  'menu.activity.activity-create': '创建活动',
  'menu.activity.activity-edit': '编辑活动',
  'menu.activity.activity-verification': '核销管理',
  
  // 用户管理
  'menu.user-management': '用户管理',
  'menu.user-management.user-list': '用户列表',
  'menu.user-management.user-detail': '用户详情',
  'menu.user-management.operator-management': '核销员管理',
  
  // 订单管理
  'menu.order': '订单管理',
  'menu.order.order-list': '订单列表',
  'menu.order.order-detail': '订单详情',
  'menu.order.refund-management': '退款管理',
  
  // 商城管理
  'menu.mall': '商城管理',
  'menu.mall.product-management': '商品管理',
  'menu.mall.product-create': '添加商品',
  'menu.mall.product-edit': '编辑商品',
  'menu.mall.inventory-management': '库存管理',
  'menu.mall.logistics-management': '物流管理',
  
  // 数据统计
  'menu.statistics': '数据统计',
  'menu.statistics.statistics-overview': '统计总览',
  'menu.statistics.activity-statistics': '活动统计',
  'menu.statistics.sales-statistics': '销售统计',
  
  // 系统管理
  'menu.system': '系统管理',
  'menu.system.system-config': '系统配置',
  'menu.system.system-logs': '操作日志',
  
  // 通用
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.logout': '退出登录',
};
